// src/components/LoadingScreen/LoadingScreen.jsx
import { observer } from 'mobx-react';
import { useStore } from '../../stores';
import CenterBox from '../CenterBox/CenterBox';
import aGif from "../../assets/images/loading_logo.gif";
import './LoadingScreen.scss';

// Overlay Component
function OverLayComponent({ children }) {
  return (
    <div className="overlay-component">
      <CenterBox>
        <div className="overlay-content">
          {children}
        </div>
      </CenterBox>
    </div>
  );
}

// Loader Component
function LoaderComponent({ size = 200 }) {
  return <img src={aGif} alt="loading" style={{ height: size, width: size }} />;
}

const LoadingScreen = observer(({ 
  isOverLay = true, 
  show = undefined,
  ignoreGlobalLoading = false
}) => {
  const { uiStore } = useStore();
  
  // Determine whether to show the loader
  const shouldShow = ignoreGlobalLoading ? show : (show !== undefined ? show : uiStore.isLoading);

  if (!shouldShow) {
    return null;
  }

  if (!isOverLay) {
    return (
      <div className="LoadingScreen">
        <LoaderComponent />
      </div>
    );
  }

  return (
    <OverLayComponent>
      <LoaderComponent />
    </OverLayComponent>
  );
});

export default LoadingScreen;